import { useCallback, useEffect, useRef } from 'react';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import constructStorageKey from '../constructStorageKey';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  const getValue = useCallback(
    (key, type = 'tenant') =>
      localStorage.getItem(constructStorageKey(key, type, sessionManagerRef.current)),
    [],
  );

  const setValue = useCallback((key, value, type = 'tenant') => {
    localStorage.setItem(constructStorageKey(key, type, sessionManagerRef.current), value);
  }, []);

  const removeValue = useCallback(
    (key, type = 'tenant') =>
      localStorage.removeItem(constructStorageKey(key, type, sessionManagerRef.current)),
    [],
  );

  return [getValue, setValue, removeValue];
};
